/* Package JSON Import will be here */
import { forEach } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import {
  orderUploadApi,
  orderConfirmRequestOTPApi,
  orderConfirmValidateOTPApi,
  bulkOrderUploadApi,
  validateCartForFocApi
} from "../services/orders";
import { submitCart } from "reducers/cart";
import { getErrorObject, errorToast } from "utilities/utils";
import { getCartDetails } from "./cart";
import {
  IOrderUploadParams,
  IBulkOrderUploadParams,
  IValidateCart
} from "models/orderModels";
import Constants from "utilities/appConstants";
import { showMsgFromJson } from "reducers/common";
import { removeLocalCartManually } from "reducers/cart";
import { submitExchangeReturnAndExchangeOrder } from "reducers/exchange/exchangeSubmit";
import { GAAddToCart } from "hooks/googleAnalyticsHooks";
import { saveSmartListTemplate } from "reducers/smartList/smartListTemplate";
/* Project Import will be here */

export const types = {
  ORDER_UPLOAD_REQUEST: "orders/ORDER_UPLOAD_REQUEST",
  ORDER_UPLOAD_SUCCESS: "orders/ORDER_UPLOAD_SUCCESS",
  ORDER_UPLOAD_FAILURE: "orders/ORDER_UPLOAD_FAILURE",
  ORDER_SUBMIT_REQUEST: "orders/ORDER_SUBMIT_REQUEST",
  ORDER_SUBMIT_SUCCESS: "orders/ORDER_SUBMIT_SUCCESS",
  LOAD_ORDER_CONFIRM_MODAL: "orders/LOAD_ORDER_CONFIRM_MODAL",
  SHOW_ORDER_CONFIRM_MODAL: "orders/SHOW_ORDER_CONFIRM_MODAL",
  HIDE_ORDER_CONFIRM_MODAL: "orders/HIDE_ORDER_CONFIRM_MODAL",
  CHANGE_QUANTITY: "orders/CHANGE_QUANTITY",
  CHANGE_CASE_QUANTITY: "orders/CHANGE_CASE_QUANTITY",
  INITIALIZE: "orders/INITIALIZE",
  INITIALIZED: "orders/INITIALIZED"
};

const initialState = {
  confirmModal: {
    show: false,
    isLoading: false
  },
  data: {},
  isLoading: false,
  error: null
};

export const orders = (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_ORDER_CONFIRM_MODAL:
      return {
        ...state,
        confirmModal: {
          show: true,
          isLoading: true
        }
      };

    case types.SHOW_ORDER_CONFIRM_MODAL:
      return {
        ...state,
        confirmModal: {
          show: true,
          isLoading: false
        }
      };

    case types.HIDE_ORDER_CONFIRM_MODAL:
      return {
        ...state,
        confirmModal: {
          show: false,
          isLoading: false
        }
      };

    case types.CHANGE_QUANTITY:
      let { id, count, isChanged } = action.payload;

      /* piece added with minQty and case added, while piece decreased as 0 make case as 0 to equal mincount in case */
      let caseCount = action.payload.case_count === 0 ? 0 : state.data[id].case_count;
      count = count === undefined ? state.data[id].count : count;

      return {
        ...state,
        data: { ...state.data, [id]: { ...state.data[id], count, isChanged, case_count: caseCount } }
      };

    case types.CHANGE_CASE_QUANTITY:
      let { product_id, case_count, caseChange } = action.payload;
      case_count = case_count === undefined ? state.data[product_id].case_count : case_count;

      return {
        ...state,
        data: { ...state.data, [product_id]: { ...state.data[product_id], case_count, isChanged: caseChange } }
      };

    case types.INITIALIZE:
      return {
        ...state,
        isLoading: true
      };

    case types.INITIALIZED:
      return {
        ...state,
        isLoading: false,
        data: { ...state.data, ...action.payload.data }
      };

    case types.ORDER_UPLOAD_REQUEST:
    case types.ORDER_UPLOAD_SUCCESS:
    case types.ORDER_UPLOAD_FAILURE:
      return orderUploadReducer(state, action);

    default:
      return state;
  }
};

const orderUploadReducer = (state, action) => {
  switch (action.type) {
    case types.ORDER_UPLOAD_REQUEST:
      return { ...state, isLoading: true };

    case types.ORDER_UPLOAD_SUCCESS:
      return { ...state, isLoading: false, error: null };

    case types.ORDER_UPLOAD_FAILURE:
      return { ...state, isLoading: false, error: action.payload.error };

    default:
      return state;
  }
};

/* This is the ActionMethod to add the products into cart */
/* orderUpload - Add the products in the order reducer to orderUploadApi */
export const orderUpload = (isFromCart = false) => {
  return async (dispatch, getState) => {
    try {
      let state = getState();
      let products = state.orders.data;
      let orderProducts: IOrderUploadParams = [];

      Object.keys(products).forEach(id => {
        const productItem = products[id];
        const productItemInfo = productItem.productInfo;

        if (productItem.isChanged) {
          if (productItemInfo && (productItem.count >= 0 || productItem.case_count >= 0)) {

            /* Check for piece QTY */
            let qty = productItem.count ? productItem.count : 0;

            /* Check for case Qty */
            if (productItem.case_count)
              qty += (productItem.case_count * productItemInfo.ConversionQty)

            orderProducts.push({
              PId: parseInt(id, 10),
              Qty: qty,
              PName: productItemInfo.ProductName,
              DiscountId: productItemInfo.DiscountId,
              SchemeId: productItemInfo.SchemeId,
              PrincipalId: productItemInfo.PrincipalId,
              ImageUrl: productItemInfo.ImageUrl,
              DistributorId: productItemInfo.DistributorId,
              UomId: productItemInfo.UomId,
              GroupId: productItemInfo.SplitId !== undefined ? productItemInfo.SplitId  : productItemInfo.GroupId,
              GroupName: productItemInfo.SplitName !== undefined ? productItemInfo.SplitName : productItemInfo.GroupName,
              UomCount: 1
            });
            productItem.isChanged = false
          }
        }
      });

      /* Check for Cart validation (Only if FOC is enabled) */
      let isAllowToPlaceOrder = true;
      const appSettings = state.appSettings;
      if (appSettings.isEnableFoc) {

        const requestObj: IValidateCart = {
          IsFOC: state.common.isFocSelected
        };

        const validateCartResponse = await validateCartForFocApi(requestObj);

        /* Assign the response object to local variable */
        isAllowToPlaceOrder = validateCartResponse.data.Data;
      }

      if (orderProducts.length > 0 && isAllowToPlaceOrder) {
        /* No need to trigger the order loader when the request is from cart page, there is separate loader for cart page */
        if (!isFromCart)
          dispatch({ type: types.ORDER_UPLOAD_REQUEST });

        /* Upload selected product to add to cart */
        await orderUploadApi(orderProducts);

        /* Fetch updated cart information */
        await dispatch(getCartDetails());

        dispatch({ type: types.ORDER_UPLOAD_SUCCESS });

        /* Order upload success toast */
        dispatch(showMsgFromJson("common.alerts.success.orderUpload", Constants.SUCCESS));

        /* To track GA add to cart order products list  */
        if (window.isEnableGA)
          GAAddToCart(orderProducts);
      }
      else {
        if (orderProducts.length === 0) {
          if (!isFromCart) {
            /* If we are not add or update anything and click the add to cart button means we need to show the error validation message to the retailer */
            dispatch(showMsgFromJson("common.alerts.error.addToCartValidation", Constants.ERROR));
          }
        }
        else if (!isAllowToPlaceOrder) {
          if (state.common.isFocSelected)
            dispatch(showMsgFromJson("products.foc.cartNonFocRequestValidation", Constants.ERROR));
          else
            dispatch(showMsgFromJson("products.foc.cartFocRequestValidation", Constants.ERROR));
        }
      }
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.ORDER_UPLOAD_FAILURE, true));

      /* Fetch updated cart information */
      await dispatch(getCartDetails());
    }
  };
};

/* Trigger, Open or close the Order OTP confirmation model */
export const toggleOrderConfirmModal = (openModel = false) => {
  return async (dispatch, getState) => {
    /* Keep the model open when the openModel property comes true */
    if (getState().orders.confirmModal.show && !openModel) {
      dispatch(hideOrderConfirmModal());
    }
    else {
      dispatch({ type: types.LOAD_ORDER_CONFIRM_MODAL });
      try {
        await orderConfirmRequestOTPApi();
        dispatch({ type: types.SHOW_ORDER_CONFIRM_MODAL });
      }
      catch (error) {
        dispatch(promiseCatchBlock(error, types.HIDE_ORDER_CONFIRM_MODAL, true));
      }
    }
  };
};

/* Validate order OTP */
export const orderConfirmValidateOTP = (otp, isFromExchangeOrder, saveOrderAsSmartList) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.LOAD_ORDER_CONFIRM_MODAL });
    try {
      await orderConfirmValidateOTPApi({ OrderOTP: otp });

      if (!isFromExchangeOrder) {
        /* Save the smart list before placing the order */
        if (saveOrderAsSmartList)
          dispatch(saveSmartListTemplate());

        /* Place the order */
        dispatch(submitCart());
      }
      else {
        dispatch(submitExchangeReturnAndExchangeOrder());
      }

      /* Close the OTP model */
      dispatch({ type: types.HIDE_ORDER_CONFIRM_MODAL });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.HIDE_ORDER_CONFIRM_MODAL, true));
    }
  };
};

/* Remove the product from order reducer */
/* TODO: Need to check and modify the remove logic */
export const removeProductFromOrderReducer = ids => {
  return (dispatch, getState) => {
    let oldOrderData = getState().orders.data
    try {
      forEach(ids, (o) => {
        oldOrderData[o].case_count = 0
        oldOrderData[o].count = 0
        oldOrderData[o].isChanged = false
      });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, "", true));
    }
  };
}

/* Load smart list products initially when the retailer click the template name */
/* Manage smart list product check and un check logic handled here using id param */
export const loadSmartListProducts = (products, id = null, isFromCheckBoxSelection = null) => {
  /* get the list of product ids from the products */
  let productIds = products.ids || [];

  /* Assign the checked product is to the array */
  if (id !== null)
    productIds = [id];

  let initState = {};
  return async (dispatch, getState) => {
    const appSettings = getState().appSettings;
    const orders = getState().orders;

    productIds.forEach(id => {
      let updatedProductCount = products.data[id].Qty;
      /* Check fox isFromCheckBoxSelection */
      if (isFromCheckBoxSelection)
        updatedProductCount = orders.data[id].count + (products.data[id].ConversionQty * orders.data[id].case_count);

      initState[id] = {
        count: (appSettings.isEnablePlaceOrderCase) ? (updatedProductCount % products.data[id].ConversionQty) : updatedProductCount,
        case_count: (appSettings.isEnablePlaceOrderCase) ? ~~(updatedProductCount / products.data[id].ConversionQty) : 0,
        isChanged: true,
        isSaleable: products.data[id].IsSaleable,
        productInfo: products.data[id]
      }
    });

    dispatch({
      type: types.INITIALIZED,
      payload: { data: initState }
    });
  }
}

/* Unload smart list products from the order reducer */
export const unLoadSmartListProducts = () => {
  return async (dispatch, getState) => {
    const smartListProducts = getState().smartListProducts;
    let initState = {};

    smartListProducts.ids.forEach(id => {
      initState[id] = {
        count: 0,
        case_count: 0,
        isChanged: false,
        isSaleable: smartListProducts.data[id].IsSaleable,
        productInfo: smartListProducts.data[id]
      }
    });

    dispatch({ type: types.INITIALIZED, payload: { data: initState } });
  }
}

export const changeQtyBasedOnGrowthFactor = (products, value, type, selectedProducts) => {
  /* get the list of product ids from the products */
  let productIds = products.ids || [];

  let initState = {};
  return async (dispatch, getState) => {
    const appSettings = getState().appSettings;
    let showSIHWarning = false;

    productIds.forEach(id => {
      let restrictSIH = false;
      let pItem = products.data[id];

      /* Check for restrict SIH */
      if (appSettings.isRestrictSIHProducts && pItem.SIH === 0) {
        restrictSIH = true;
        showSIHWarning = true;
      }

      /*  growth factor logic only applicable for checkbox value selected products */
      if (selectedProducts.includes(id) && !restrictSIH) {
        let totalValue = value;
        if (type === Constants.GROWTH_FACTOR_QUANTITY_PERCENTAGE) {
          const percentageValue = ((value * pItem.Qty) / 100);
          totalValue = Math.round(percentageValue) + pItem.Qty;
        }

        /* Check for min order qty */
        if (appSettings.isEnableMinOrderQty && pItem.MinORDQty !== 0) {
          if (totalValue >= pItem.MinORDQty && (totalValue <= pItem.MaxORDQty || pItem.MaxORDQty === 0)) {
            totalValue = (Math.ceil(totalValue / pItem.MinORDQty) * pItem.MinORDQty);
          }
          else {
            totalValue = pItem.MinORDQty;
          }
        }

        let updatedCount = 0;
        let updatedCaseCount = 0;
        if (appSettings.isEnablePlaceOrderCase) {
          updatedCount = (totalValue % pItem.ConversionQty) <= 9999 ? (totalValue % pItem.ConversionQty) : 9999;
          updatedCaseCount = ~~(totalValue / pItem.ConversionQty) <= 9999 ? ~~(totalValue / pItem.ConversionQty) : 9999;
        }
        else {
          updatedCount = totalValue <= 9999 ? totalValue : 9999;
          updatedCaseCount = 0
        }

        initState[id] = {
          count: updatedCount,
          case_count: updatedCaseCount,
          isChanged: true,
          isSaleable: pItem.IsSaleable,
          productInfo: pItem
        }
      }
    });

    dispatch({ type: types.INITIALIZED, payload: { data: initState } });

    /* Check for stock 0 error message */
    if (showSIHWarning)
      dispatch(showMsgFromJson("common.alerts.warning.smartListOutOfStockError", Constants.WARNING));
  }
}

/* Initialize order reducer */
export const initializeOrderState = (key = Constants.REDUCER_PRODUCTS) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: types.INITIALIZE });

      let initState = {};
      let products = getState()[key];

      products.ids.forEach(id => {
        const productItem = products.data[id];
        const productItemId = productItem.ProductId;
        const cartItem = getState().cart.data[productItemId];

        initState[productItemId] = {
          count: (cartItem && cartItem.pieceQTY) ? cartItem.pieceQTY : 0,
          case_count: (cartItem && cartItem.caseQTY) ? cartItem.caseQTY : 0,
          isChanged: (cartItem && cartItem.isChanged) ? cartItem.isChanged : false,
          isSaleable: productItem.IsSaleable,
          productInfo: productItem
        };
      });

      /* Update the order reducer state */
      dispatch({ type: types.INITIALIZED, payload: { data: initState } });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, "", true));
    }
  };
};

export const hideOrderConfirmModal = () => {
  return {
    type: types.HIDE_ORDER_CONFIRM_MODAL
  };
};

export const changeQuantity = payload => {
  return {
    type: types.CHANGE_QUANTITY,
    payload
  };
};

export const changeCaseQuantity = payload => {
  return {
    type: types.CHANGE_CASE_QUANTITY,
    payload
  };
};

/* Remove all the locally selected product from the order and cart reducer */
export const removeAllChangedProductFromOrderReducer = (needAlert = true) => {
  return (dispatch, getState) => {
    let orderReducerData = getState().orders.data
    try {
      /* Remove all the locally selected product from the order reducer */
      forEach(orderReducerData, (o, index) => {
        orderReducerData[index].case_count = 0
        orderReducerData[index].count = 0
        orderReducerData[index].isChanged = false
      });

      dispatch({
        type: types.INITIALIZED,
        payload: { data: orderReducerData }
      });

      /* Remove all the locally selected product from the cart reducer */
      dispatch(removeLocalCartManually());

      /* Success response */
      if (needAlert)
        dispatch(showMsgFromJson(`common.alerts.success.removedProductsSelectedForAddToCart`, Constants.SUCCESS));
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, "", true));
    }
  };
}

/* Bulk order upload */
export const bulkOrderUpload = (qty, subCatId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: types.ORDER_UPLOAD_REQUEST });

      const requestObject: IBulkOrderUploadParams = {
        AttrFilter: getState().attrFilter.selectedAttrFilter,
        FilterLevelCode: "SUCAT",
        FilterIdList: [
          subCatId
        ],
        Qty: qty,
        NeedFOC: getState().common.isFocSelected,
        IsRelevant: false
      };
      const response = await bulkOrderUploadApi(requestObject);

      /* Update the cart data */
      await dispatch(getCartDetails());

      dispatch({ type: types.ORDER_UPLOAD_SUCCESS });

      /* Order upload success toast */
      dispatch(showMsgFromJson("common.alerts.success.orderUpload", Constants.SUCCESS));

      /* To track GA add to cart product list */
      if (window.isEnableGA)
        GAAddToCart(response.data.Data.ProductList);

      /* Check for SIH 0 warning */
      if (response.data.isShowSIHWarning)
        dispatch(showMsgFromJson("common.alerts.warning.bulkOrderOutOfStockBasedAvailable", Constants.WARNING));

      /* Re initialize order state */
      await dispatch(initializeOrderState());
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.ORDER_UPLOAD_FAILURE, true));
    }
  };
}

/* Add all relevant SO products to cart */
export const relevantSoOrderUpload = () => {
  return async (dispatch, getState) => {
    /* Get products reducer to get the filter */
    const products = getState().products;

    try {
      dispatch({ type: types.ORDER_UPLOAD_REQUEST });

      let requestObject: IBulkOrderUploadParams = {
        AttrFilter: getState().attrFilter.selectedAttrFilter,
        NeedFOC: getState().common.isFocSelected,
        IsRelevant: true
      };

      /* Spread the CAT, SUCAT, BR object */
      for (let i = 0; i < Constants.filterOrder.length; i++) {
        const key = Constants.filterOrder[i];
        if (products.filter[key].FilterIdList.length !== 0) {
          if (products.filter[key].FilterIdList[0]) {
            requestObject = {
              ...requestObject,
              ...products.filter[key]
            };
          }
        }
      }

      const response = await bulkOrderUploadApi(requestObject);

      /* Update the cart data */
      await dispatch(getCartDetails());

      dispatch({ type: types.ORDER_UPLOAD_SUCCESS });

      /* Order upload success toast */
      dispatch(showMsgFromJson("common.alerts.success.orderUpload", Constants.SUCCESS));

      /* To track GA add to cart product list */
      if (window.isEnableGA)
        GAAddToCart(response.data.Data.ProductList);

      /* Check for SIH 0 warning */
      if (response.data.isShowSIHWarning)
        dispatch(showMsgFromJson("common.alerts.warning.suggestedOrderOutOfStockBasedAvailable", Constants.WARNING));

      /* Re initialize order state */
      await dispatch(initializeOrderState());
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.ORDER_UPLOAD_FAILURE, true));
    }
  };
}

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
  return (dispatch) => {
    const { message, errorCode } = getErrorObject(error);

    /* Update the error response in the store */
    if (type !== "")
      dispatch({ type: type, payload: { error: message } });

    /* Show error message */
    if (showToast) {
      /* If error code is exist show the error code message or show the error message returned by the API request */
      if (errorCode !== "")
        dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
      else
        errorToast({ content: message });
    }
  }
};